<template>
  <footer
    :id="props.id"
    class="tw-relative tw-bg-white tw-px-4 tw-py-8 tw-text-primary-grey-950 dark:tw-bg-primary-grey-100 dark:tw-text-primary-grey-700"
  >
    <div
      v-if="props.logo || props.products.length"
      class="w-relative tw-mb-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-2"
    >
      <div
        v-if="props.logo"
        class="w-relative tw-col-span-1 tw-mb-4 tw-flex tw-justify-start"
      >
        <img
          class="tw-max-h-[90px] tw-w-auto"
          alt="company logo"
          :src="props.logo"
        />
      </div>
      <div
        class="w-relative tw-col-span-1 tw-flex tw-justify-start md:tw-justify-end"
      >
        <div class="tw-flex tw-flex-col">
          <div
            v-if="props.products.length > 0"
            class="tw-mb-2 tw-text-base tw-font-normal tw-text-primary-grey-950 dark:tw-text-primary-grey-700"
          >
            {{ "Other Products" }}
          </div>
          <div
            v-for="(product, idx) in props.products"
            :key="idx"
            class="tw-mb-2 tw-h-14 tw-w-[260px] tw-rounded-sm tw-border tw-border-primary-grey-500/5 tw-bg-[#47647d] tw-p-1.5 dark:tw-bg-white"
          >
            <a
              :href="product.link"
              :data-test-id="`footer-product-${product.title.toLowerCase()}`"
              target="_blank"
              class="tw-inline-flex tw-h-full tw-w-full tw-justify-between"
            >
              <div
                class="tw-inline-flex tw-h-full tw-flex-col tw-justify-between"
              >
                <div class="tw-inline-flex tw-h-6 tw-flex-row tw-items-center">
                  <img :src="product.icon" class="tw-h-6 tw-w-auto" />
                  <span
                    class="tw-ml-2 tw-text-sm tw-font-semibold tw-text-primary-grey-950 dark:tw-text-primary-grey-700"
                    >{{ product.title }}</span
                  >
                </div>
                <div
                  class="tw-text-xs tw-font-normal tw-text-primary-grey-950 dark:tw-text-primary-grey-700"
                >
                  {{ product.description }}
                </div>
              </div>
              <div
                class="tw-inline-flex tw-h-full tw-items-center tw-text-sm tw-font-bold tw-text-primary-grey-950 dark:tw-text-primary-grey-700"
              >
                {{ "Try Now" }}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="tw-relative tw-flex tw-flex-col tw-items-center">
      <div class="tw-text-primary-grey-950 dark:tw-text-primary-grey-700">
        {{ poweredByText }}
      </div>
      <div
        v-if="version"
        class="tw-text-primary-grey-950 dark:tw-text-primary-grey-700"
      >
        {{ `v ${props.version}` }}
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import type { Product } from "./types";
import { computed } from "vue";

export interface ClFooterProps {
  logo?: string;
  id?: string;
  products?: Product[];
  version?: string;
  mspName?: string;
}

const poweredByText = computed<string>(() => {
  return `Powered by ${props.mspName || "CyberSentriq"}`;
});

const props = withDefaults(defineProps<ClFooterProps>(), {
  id: "app-footer",
  products: () => [],
  version: "",
});
</script>
